import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__special_collections_info } from '@shared/dto/collection/DTO__special_collections_info';
import { STATE__collections } from '../STATE__collections';
import { get_or_create_special_collection_info_by_workspace_id } from './get_or_create_special_collection_info_by_workspace_id';

//todo: use hash_content instead of id
export function try_add_images_ids_to_special_collections(state: STATE__collections, workspace_id: string, type: string, hashes_content: string[]) {
  let special_collection_info = get_or_create_special_collection_info_by_workspace_id(state, workspace_id);
  special_collection_info = try_add_images_ids_to_collection(workspace_id, type, hashes_content, special_collection_info);
  state.special_collections_info_map.set(workspace_id, special_collection_info);

  state.special_collections_info_current = try_add_images_ids_to_collection(workspace_id, type, hashes_content, state.special_collections_info_current);

  //need to force a re-render
  state.special_collections_info_map = new Map(state.special_collections_info_map);
}

function try_add_images_ids_to_collection(
  workspace_id: string,
  type: string,
  hashes_content: string[],
  special_collection_info: DTO__special_collections_info,
) {
  if (special_collection_info.workspace_id != workspace_id) return special_collection_info;

  let out = special_collection_info.clone();

  switch (type) {
    case ENUM__workspace_entity.COLLECTION_FAVORITES: {
      out.images_ids_favorites = new Set([...special_collection_info.images_ids_favorites, ...hashes_content]);
      break;
    }

    case ENUM__workspace_entity.COLLECTION_VIEWED_ON_SEARCH: {
      out.images_ids_viewed_on_search = new Set([...special_collection_info.images_ids_viewed_on_search, ...hashes_content]);
      break;
    }

    case ENUM__workspace_entity.COLLECTION_UPLOADS:
    case ENUM__workspace_entity.COLLECTION_GENERATED:

    case ENUM__workspace_entity.COLLECTION_CUSTOM:

    case ENUM__workspace_entity.ENTITY_SEARCH:
    case ENUM__workspace_entity.ENTITY_GENERATION:
    case ENUM__workspace_entity.ENTITY_USER_TASK:
      //do nothing
      break;

    default:
      not_implemented_type(type);
  }

  return out;
}
